export default class ProductAttributes {
    static init (selector)
    {
        if(!$('#v-pills-variables, #attributeRepeater', selector).length)
            return false;

        const $repeaterContainer = $('#attributeRepeater', selector), $addButton = $('[data-repeater-create]', $repeaterContainer), $repeaterTemplate = $repeaterContainer.find('[data-repeater-item]').first(),
            $attributeSelect = $('#addAttribute', selector), $attributeApi = $attributeSelect[0].selectize, termSrc = $('select', $repeaterTemplate).attr('data-src')

        $attributeApi.on('item_add', function (value, $item){
            JsLoadingOverlay.show();

            if(isNaN(value))
                $('select.attributesSelect', $repeaterTemplate).removeAttr('data-src');
            else
                $('select.attributesSelect', $repeaterTemplate).attr('data-src', termSrc.replace('999', value));

            $('input[name*="attribute_id"]', $repeaterTemplate).val(value);

            $('p', $repeaterTemplate).text($item.text());
            JsLoadingOverlay.hide();
        });

        $addButton.on('click', function () {
            JsLoadingOverlay.show();

            attributeChange();

            let attribute = $attributeApi.options[$attributeApi.getValue()];
            $('.attribute-group', $repeaterContainer.find('[data-repeater-item]').last()).text(attribute.name);

            $('select.attributesSelect', $repeaterTemplate).attr('data-src', termSrc);
            $attributeApi.clear();
            JsLoadingOverlay.hide();
        });

        function attributeChange()
        {
            $('#attributeChange', selector).remove();
            $('<span id="attributeChange">Attributes have been edited, update for latest options</span>').insertBefore($('#update_variables'))
        }

    }
}
